import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { MatchmakerIcon } from 'dibs-matchmaker-icon/exports/MatchmakerIcon';
import { Button } from 'dibs-elements/exports/Button';
import { sessionStorage, localStorage } from 'dibs-browser-storage';

import style from '../styles/DesignerConnection.scss';
import {
    CONFIRMATION_TYPE_CONTACT,
    setDesignerConnectionMessageShown,
    trackCtaClick,
} from '../helpers/designerConnectionTracking';

const STORAGE_KEY = 'confirmMessageDesignerConnection';

export function isDesignerConnectionMessageVisible() {
    const sessionsCount = sessionStorage.getItem(STORAGE_KEY) || 0;
    const lifetimeCount = localStorage.getItem(STORAGE_KEY) || 0;
    const isVisible = sessionsCount < 2 && lifetimeCount < 6;

    if (isVisible) {
        sessionStorage.setItem(STORAGE_KEY, sessionsCount + 1);
        localStorage.setItem(STORAGE_KEY, lifetimeCount + 1);
    }

    return isVisible;
}

export class DesignerConnection extends Component {
    componentDidMount() {
        setDesignerConnectionMessageShown(CONFIRMATION_TYPE_CONTACT);
    }
    render() {
        return (
            <div className={style.wrapper}>
                <MatchmakerIcon
                    wrapperClass={style.matchmakerWrapper}
                    personClass={style.matchmakerIcon}
                    professionalClass={style.matchmakerIcon}
                    dividerClass={style.iconDivider}
                />
                <div className={style.title}>
                    <FormattedMessage
                        id="dbl.contactSellerModal.designerConnection.header"
                        defaultMessage="Redesigning Your Space?"
                    />
                </div>

                <img
                    className={style.image}
                    src="http://a.1stdibscdn.com/assets/trade/matchmaker/modal_confirmation_prompt.jpg?width=600"
                />

                <div className={style.description}>
                    <FormattedMessage
                        id="dbl.contactSellerModal.designerConnection.description"
                        defaultMessage="Try our free service. Designer Connection! Simply take our quiz and you'll receive hand-picked recommendations based on your style and needs."
                    />
                </div>

                <Button
                    href="/trade/designer-connection/"
                    opensInNewWindow
                    className={style.cta}
                    onClick={() =>
                        this.props.trackCtaClick
                            ? this.props.trackCtaClick()
                            : trackCtaClick(CONFIRMATION_TYPE_CONTACT)
                    }
                >
                    <FormattedMessage
                        id="dbl.contactSellerModal.designerConnection.cta"
                        defaultMessage="Get Started"
                    />
                </Button>
            </div>
        );
    }
}

DesignerConnection.propTypes = {
    trackCtaClick: PropTypes.func,
};
